"use client";

import { useState, type FormEvent } from "react";
import { useRouter } from "next/navigation";
import { signInWithPassword, type SignInOutcome } from "@/lib/auth/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/shared/field";
import { FormError } from "./form-error";

const MESSAGES: Record<Exclude<SignInOutcome, { ok: true }>["reason"], string> = {
  invalid: "El email o la contraseña no son correctos.",
  rate_limited: "Demasiados intentos. Espera unos minutos y vuelve a probar.",
  network: "No se pudo conectar con el servidor. Vuelve a intentarlo.",
};

/** Email and password. The same message whether the email exists or not. */
export function LoginForm() {
  const router = useRouter();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    const outcome = await signInWithPassword(email.trim(), password);
    if (outcome.ok) {
      // The workspace decides on the server whether the password must be changed first.
      router.replace("/");
      router.refresh();
      return;
    }
    setPassword("");
    setError(MESSAGES[outcome.reason]);
    setBusy(false);
  };

  return (
    <form onSubmit={submit} className="flex flex-col gap-4" aria-busy={busy}>
      <Field id="login-email" label="Email">
        <Input id="login-email" type="email" autoComplete="username" required autoFocus value={email} onChange={(event) => setEmail(event.target.value)} />
      </Field>
      <Field id="login-password" label="Contraseña">
        <Input id="login-password" type="password" autoComplete="current-password" required value={password} onChange={(event) => setPassword(event.target.value)} />
      </Field>
      <FormError message={error} />
      <Button type="submit" disabled={busy}>
        {busy ? "Entrando…" : "Entrar"}
      </Button>
      <p className="text-label text-muted-foreground">¿Has olvidado la contraseña? Pide a un administrador que te la restablezca.</p>
    </form>
  );
}
